import DOMReady from '../utils/DOMReady'
import Accordion from '../modules/accordion'

// eslint-disable-next-line no-unused-vars
import css from '../../css/blocks/acordion-horarios.scss'

class AcordionHorarios {
  constructor(el) {
    this.container = el
    this.accordion = null
    this.accordionEl = this.container.querySelector('.accordion')
    this.init()
  }

  init() {
    if (this.accordionEl) {
      this.accordion = new Accordion(this.accordionEl)
    }
  }
}

DOMReady(() => {
  const elements = document.querySelectorAll('.schedule-accordion')
  if (elements !== null) {
    elements.forEach(element => new AcordionHorarios(element))
  }
})
